export const environment = {
  production: false,
  env: 'develop',
  baseUrlAPI: 'https://0tvxrr8ci8.execute-api.us-east-1.amazonaws.com/prod',
  baseWssAPI: '',
  baseUrlAPINEW: 'https://manage-api.cbntech.xyz',
  apiCassinelli: 'https://api-cassinelli-dev.cbntech.xyz',
  bearerTokenServer: 'Bearer 011235813213455891442333',
  platformApi: "https://platform-api.cbntech.xyz"
};
